__turbopack_context__.v({
  "all": "zuUzuW_all",
  "all2": "zuUzuW_all2",
  "all3": "zuUzuW_all3",
  "col2": "zuUzuW_col2",
  "col3": "zuUzuW_col3",
  "col4": "zuUzuW_col4",
  "desktop": "zuUzuW_desktop",
  "featuresCard___5TQtD": "zuUzuW_featuresCard___5TQtD",
  "featuresCard__bRhPy": "zuUzuW_featuresCard__bRhPy",
  "featuresCard__bwFZy": "zuUzuW_featuresCard__bwFZy",
  "featuresCard__eatYl": "zuUzuW_featuresCard__eatYl",
  "featuresCard__flHle": "zuUzuW_featuresCard__flHle",
  "featuresCard__fszWh": "zuUzuW_featuresCard__fszWh",
  "featuresCard__g0MFs": "zuUzuW_featuresCard__g0MFs",
  "featuresCard__gb6VK": "zuUzuW_featuresCard__gb6VK",
  "featuresCard__gfcXr": "zuUzuW_featuresCard__gfcXr",
  "featuresCard__ig9AJ": "zuUzuW_featuresCard__ig9AJ",
  "featuresCard__iiiYe": "zuUzuW_featuresCard__iiiYe",
  "featuresCard__ipvSa": "zuUzuW_featuresCard__ipvSa",
  "featuresCard__jnFlJ": "zuUzuW_featuresCard__jnFlJ",
  "featuresCard__nSip7": "zuUzuW_featuresCard__nSip7",
  "featuresCard__ry66P": "zuUzuW_featuresCard__ry66P",
  "featuresCard__sOpi": "zuUzuW_featuresCard__sOpi",
  "featuresCard__uu09J": "zuUzuW_featuresCard__uu09J",
  "featuresCard__vU6E1": "zuUzuW_featuresCard__vU6E1",
  "featuresCard__vo6Zy": "zuUzuW_featuresCard__vo6Zy",
  "featuresProductHeader___25K2Y": "zuUzuW_featuresProductHeader___25K2Y",
  "featuresProductHeader___7Rpxq": "zuUzuW_featuresProductHeader___7Rpxq",
  "featuresProductHeader__rnQty": "zuUzuW_featuresProductHeader__rnQty",
  "h2___3Hu8L": "zuUzuW_h2___3Hu8L",
  "h2__fFdiH": "zuUzuW_h2__fFdiH",
  "h2__xJcJt": "zuUzuW_h2__xJcJt",
  "header": "zuUzuW_header",
  "header2": "zuUzuW_header2",
  "header3": "zuUzuW_header3",
  "header4": "zuUzuW_header4",
  "img___3AIFh": "zuUzuW_img___3AIFh",
  "img___4YnRm": "zuUzuW_img___4YnRm",
  "img___6XVwM": "zuUzuW_img___6XVwM",
  "img___7PVv": "zuUzuW_img___7PVv",
  "img___9POVn": "zuUzuW_img___9POVn",
  "img__ceYrC": "zuUzuW_img__ceYrC",
  "img__e1NwB": "zuUzuW_img__e1NwB",
  "img__i1BVf": "zuUzuW_img__i1BVf",
  "img__iyqSa": "zuUzuW_img__iyqSa",
  "img__jgPD": "zuUzuW_img__jgPD",
  "img__jyi1W": "zuUzuW_img__jyi1W",
  "img__l2YJb": "zuUzuW_img__l2YJb",
  "img__nhAjy": "zuUzuW_img__nhAjy",
  "img__nlflX": "zuUzuW_img__nlflX",
  "img__oSYh": "zuUzuW_img__oSYh",
  "img__qmmb4": "zuUzuW_img__qmmb4",
  "img__qxEqC": "zuUzuW_img__qxEqC",
  "img__rhlDw": "zuUzuW_img__rhlDw",
  "img__s9Afo": "zuUzuW_img__s9Afo",
  "img__ueeYy": "zuUzuW_img__ueeYy",
  "img__w5X7K": "zuUzuW_img__w5X7K",
  "key2": "zuUzuW_key2",
  "key3": "zuUzuW_key3",
  "key4": "zuUzuW_key4",
  "list11": "zuUzuW_list11",
  "list2": "zuUzuW_list2",
  "list3": "zuUzuW_list3",
  "list4": "zuUzuW_list4",
  "list6": "zuUzuW_list6",
  "list7": "zuUzuW_list7",
  "listItem___22AfJ": "zuUzuW_listItem___22AfJ",
  "listItem___59ZKm": "zuUzuW_listItem___59ZKm",
  "listItem__dTcVv": "zuUzuW_listItem__dTcVv",
  "logo__alngc": "zuUzuW_logo__alngc",
  "logo__l0Sm": "zuUzuW_logo__l0Sm",
  "logo__ua5X6": "zuUzuW_logo__ua5X6",
  "mobile": "zuUzuW_mobile",
  "myEvaluations": "zuUzuW_myEvaluations",
  "row": "zuUzuW_row",
  "row11": "zuUzuW_row11",
  "row5": "zuUzuW_row5",
  "row6": "zuUzuW_row6",
  "row7": "zuUzuW_row7",
  "row8": "zuUzuW_row8",
  "row9": "zuUzuW_row9",
  "sections": "zuUzuW_sections",
  "sections2": "zuUzuW_sections2",
  "sections3": "zuUzuW_sections3",
  "svg__aEdPb": "zuUzuW_svg__aEdPb",
  "svg__qjoSx": "zuUzuW_svg__qjoSx",
  "svg__sbYDg": "zuUzuW_svg__sbYDg",
  "tablet": "zuUzuW_tablet",
  "title": "zuUzuW_title",
  "title2": "zuUzuW_title2",
  "title3": "zuUzuW_title3",
});
